<div class="edp-es-order-steps-container">
    <div class="edp-es-order-steps">
        <ng-container *ngFor="let step of order?.steps; let index = index">
            <div
                class="separator"
                [ngClass]="{ finished: index < indexActive || order.isCompleted, active: index === indexActive && !order.isCompleted }"
            ></div>

            <div
                class="bullet position-relative"
                [ngClass]="{
                    finished: index < indexActive || order.isCompleted,
                    active: index === indexActive && !order.isCompleted,
                    cancelled: order.isCanceled
                }"
            >
                <ng-container *ngIf="index <= indexActive || order.isCompleted">
                    <i aria-hidden="true" [ngClass]="index < indexActive || order.isCompleted ? 'icon-edponline-Bop-072' : step.icon"></i>
                </ng-container>
                <span class="bullet-label" [ngClass]="{ cancelled: order.isCanceled }">
                    {{ step.title | translate }}
                </span>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="!order.isCompleted">
        <div class="edp-es-order-substeps d-none d-md-flex flex-column" [ngClass]="{spacing: indexActive === order.steps.length - 1}">
            <span class="edp-es-order-substeps-title">{{ "pt.edp.edponline.es.widget.order.steps.next" | translate }}</span>

            <div class="edp-es-order-substeps-list d-flex flex-column">
                <ng-container *ngFor="let substep of order.steps[indexActive].substeps | filterHide">
                    <div class="edp-es-order-substeps-list-item">
                        <div class="d-flex flex-column align-items-center">
                            <div class="bullet"></div>
                            <div class="separator"></div>
                        </div>
                        <p [innerHTML]="substep.description | translate"></p>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>
